export { P71StoreDetailsPage as default } from './components/P71StoreDetailsPage';
